const LeaveIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1rem"
        viewBox="0 -960 960 960"
        width="1rem"
        fill="currentColor">
        <path d="M200-120q-33 0-56.5-23.5T120-200v-160h80v160h560v-560H200v160h-80v-160q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm220-160-56-58 102-102H120v-80h346L364-622l56-58 200 200-200 200Z" />
    </svg>
);

export { LeaveIcon };
